import React, { useState, useEffect, useContext } from 'react';

import PropTypes from "prop-types";
import { withStyles } from "@mui/styles";
import { makeStyles } from "@mui/styles";
import styles from "assets/jss/material-dashboard-pro-react/cardImagesStyles";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import MuiDialogContent from "@mui/material/DialogContent";
import MuiDialogActions from "@mui/material/DialogActions";
import CustomDialogTitle from "components/Dialog/CustomDialogTitle.js";
import CardBody from "components/Card/CardBody";
import Card from "components/Card/Card";
import {markerInfoCard,markerInfoCardBody} from "assets/jss/material-dashboard-pro-react/components/ShowMarkerCardStyle";
import { metertext } from 'variables/meters';
import { energyData, statusData } from "variables/lists/meters";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import ViewMeterDataDialog from "components/RTMeters/Meters/ViewMeterDataDialog";
import VisibilityIcon from "@mui/icons-material/Visibility";

//require("dotenv").config();
const useStyles = makeStyles(styles);
const useStyles2 = makeStyles((theme) => ({
    dataButton: {
        color: "#FFFFFF",
        backgroundColor: "#91C73C",
        fontWeight: "bold",
        display: "flex",
        justifyContent: "space-around",
        marginTop: "25px",
        marginRight: "auto",
        width: "220px",
        height: "38px",
        "&:hover": {
            backgroundColor: "#91C73C",
            boxShadow: "0px 11px 15px -7px rgb(0 0 0 / 20%)",
        },
    }
}));

const DialogContent = withStyles((theme) => ({
    root: {
        padding: '16px',
    },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
    root: {
        margin: 0,
        padding: '8px',
    },
}))(MuiDialogActions);


export function ShowMarkerCard(props) {
    const advancedSearchContext = useContext(AdvancedSearchContext);
    const { groupInfoListById, setPage } = advancedSearchContext;
    const [openMeterData, setOpenMeterData] = useState(false);

    const { onClose, meterid, meters } = props;
    const classes = useStyles();
    const classes2 = useStyles2();

    const [meter, setMeter] = useState(null);


    useEffect(() => {
        if (meterid && meters) {
            let metertmp = meters.find((m) => m.id === meterid);
            setMeter(metertmp);
        }
    }, [meterid, meters])

    const handleViewMeterDataOpen = () => {
        setOpenMeterData(true);
    };
    const handleViewMeterDataClose = () => {
        setOpenMeterData(false);
    };


    return (

        <>
            <Card style={markerInfoCard}>
                {/* <Button onClick={onClose} justIcon style={closeButton} size={'sm'} simple>
                <CloseIcon />
            </Button> */}
                {
                    meter ?
                        <CardBody style={markerInfoCardBody}>
                            <div className={"infocardtitle"}>{meter.meternumber}</div>
                            <div className={"infocardcontent"}>
                                <div className={"infocardinfo"}>{energyData.find((x) => x.id == meter.energy).name}</div>
                                <div className={"infocardinfo"}>{metertext.status + ' : ' + statusData.find((x) => x.id == meter.details.status).name}</div>
                                <div className={"infocardinfo"}>{metertext.serialnumber + ' : ' + (meter.details?.serialnumber || '')}</div>
                                <div className={"infocardinfo"}>{metertext.key + ' : ' + (meter.details?.clef || '')}</div>
                                {
                                    meter.energy === 'electricity' ?
                                        <div className={"infocardinfo"}>{metertext.segment + ' : ' + (meter.details?.segment || '')}</div> :
                                        meter.energy === 'gas' ?
                                            <div className={"infocardinfo"}>{metertext.cja + ' : ' + (meter.details?.cja || '')}</div> :
                                            meter.energy === 'water' ?
                                                <div className={"infocardinfo"}>{metertext.diameter + ' : ' + (meter.details?.diameter || '')}</div> : <></>
                                }
                                <div className={"infocardinfo"}>{metertext.account + ' : ' + (groupInfoListById["" + meter.accountid] || "")}</div>
                                <div className={"infocardinfo"}>{metertext.address + ' : ' + (meter.details?.address?.description || '')}</div>
                                <div className={"infocardinfo"}>{metertext.description + ' : ' + (meter.details?.description || '')}</div>

                            </div>
                            {
                                (meter.energy === 'electricity' || meter.energy === 'gas') ?
                                    <Button
                                        className={classes2.dataButton}
                                        onClick={() => { handleViewMeterDataOpen(); }}
                                    >
                                        <VisibilityIcon fontSize="medium" style={{marginBottom:"2px"}} />
                                        Voir les données
                                    </Button>
                                    : <></>
                            }
                        </CardBody>
                        : <></>
                }

            </Card>
            <Dialog
                onClose={handleViewMeterDataClose}
                aria-labelledby="edituser-dialog-title"
                fullWidth="true"
                maxWidth="md"
                open={openMeterData}
            >
                <CustomDialogTitle id="customized-dialog-title" onClose={handleViewMeterDataClose}>
                    Données de {meter?.meternumber}
                </CustomDialogTitle>
                <DialogContent dividers>
                    <ViewMeterDataDialog
                        meter={meter}
                        closeModal={handleViewMeterDataClose}
                        energy={meter?.energy}
                    />
                </DialogContent>
                <DialogActions></DialogActions>
            </Dialog>
        </>
    );
}

ShowMarkerCard.propTypes = {
    showCard: PropTypes.bool,
    onClose: PropTypes.func,
    locationInfo: PropTypes.object
}